module.exports = __webpack_public_path__ + "static/media/IMG_041.12e04403.JPG";